import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Homepage from "./pages/homepage";
import TermsAndConditions from "./pages/termsandconditions";
import CustomerCare from "./pages/customercare";
import AdminPage from "./pages/adminpage";
import UsersDetails from "./pages/userdetails";
import AdminSettings from "./pages/settings";
function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Homepage />} />
        <Route path="/customer-care" element={<CustomerCare />} />
        <Route path="/terms-and-conditions" element={<TermsAndConditions />} />
        <Route path="/admin" element={<AdminPage />} />
        <Route path="/admin/users-details" element={<UsersDetails />} />
        <Route path="/admin/settings" element={<AdminSettings />} />
      </Routes>
    </Router>
  );
}

export default App;
